class Cookie {
  public static get instance(): Cookie {
    if (!Cookie.sInstance) {
      Cookie.sInstance = new Cookie();
    }
    return Cookie.sInstance;
  }

  private static sInstance: Cookie;

  public getCookie(key: string) {
    const reg = new RegExp(`(^| )${key}=([^;]*)(;|$)`);
    const matches = document.cookie.match(reg);
    if (matches) {
      return matches[2];
    } else {
      return null;
    }
  }

  public setCookie(key: string, value: string, path: string, expireDays?: number) {
    const expDate = new Date();

    if (expireDays) {
      expDate.setUTCHours(expDate.getUTCHours() + 8); // 時區為+8
      expDate.setDate(expDate.getDate() + expireDays);
    }

    document.cookie =
      key + "=" + value
      + ";path=" + path
      + (expireDays == null ? "" : ";expires=" + expDate.toUTCString());
  }

  public delCookie(key: string, path: string) {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);

    const value = this.getCookie(key);
    if (value != null) {
      document.cookie = key + "=" + value + ";path=" + path + ";expires=" + exp.toUTCString();
    }
  }
}

const cookie = Cookie.instance;

export { cookie as Cookie };
